import { processPart } from './processor.js';
import { directive } from './directive.js';
const untils = new WeakMap();
export const until = directive((...promises) => (part) => {
    if (!untils.has(part))
        untils.set(part, { i: promises.length });
    const state = untils.get(part);
    for (let i = 0; i < promises.length; i += 1) {
        if (promises[i] instanceof Promise) {
            // eslint-disable-next-line github/no-then
            Promise.resolve(promises[i]).then(value => {
                if (i < state.i) {
                    state.i = i;
                    processPart(part, value);
                }
            });
        }
        else if (i <= state.i) {
            state.i = i;
            processPart(part, promises[i]);
        }
    }
});
//# sourceMappingURL=until.js.map